export default "__VITE_ASSET__C7q1Cvbr__"